// import { BrowserRouter as Router, Routes, Route, Outlet  } from "react-router-dom";
// import './App.css';
// import LoginScreen from "./pages/login-screen/LoginScreen";
// import ForgotPassword from "./pages/forgot-password/ForgotPassword";
// import DashboardPage from "./pages/dashboard/Dashboard";
// import Appointments from "./pages/appointments/Appointments";
// import PharamacyInventory from "./pages/pharamacy-Inventory/PharamacyInventory";
// import UploadDocuments from "./pages/upload-documents/UploadDocuments";
// import DocumentsUnderProcess from "./pages/document-under-process/DocumentsUnderProcess";
// import UploadRequiredDocuments from "./pages/upload-required-documents/UploadRequiredDocuments";
// import Header from "./components/header/Header";
// import Patients from "./pages/patients/Patients";
// import PatientsProfile from "./pages/patients-profile/PatientsProfile";
// import PatientRegistration from "./pages/patient-registration/PatientRegistration";
// import Wallet from "./pages/wallet/Wallet";
// import WithdrawFromWallet from "./pages/withdraw-from-wallet/WithdrawFromWallet";
// import MyProfile from "./pages/my-profile/MyProfile";
// import { useTranslation } from "react-i18next";
// import Introduction from "./pages/introduction/Introduction";
// import "./i18n";
// import Setting from "./pages/setting/Setting";
// import Faqs from "./pages/faqs/faq";
// import DoctorSupport from "./pages/doctor-support/DoctorSupport";
// import Chat from "./pages/chat/Chat";
// import PharmacyDashboard from "./pages/Pharmacy-Dashboard/PharmacyDashboard";
// import PharmacyAllOrder from "./pages/Pharmacy-All-Order/PharmacyAllOrder";
// import PharmacyOrdersRequest from "./pages/pharmacy-orders-request/PharmacyOrdersRequest";
// import PharmacyOrdersHistory from "./pages/pharmacy-orders-history/PharmacyOrdersHistory";
// import OrderDetails from "./pages/PharmacyOrderDetails/OrderDetails";
// import PharmacyManageProduct from "./pages/pharmacy-add-medicine-to-inventory/PharmacyAddMedicineToInventory";
// import PharmacyEditManageProduct from "./pages/pharmacy-edit-manage-product/PharmacyEditManageProduct";
// import PharmacyAddMedicineToInventory from "./pages/pharmacy-add-medicine-to-inventory/PharmacyAddMedicineToInventory";
// import ResetPassword from "./pages/reset-password/ResetPassword";
// import UploadDocumentsPharma from "./pages/pharmacy-upload-document/UploadDocumentsPharma";
// import DoctorCalendar from "./pages/calender/DoctorCalendar";

// function LayoutWithHeader({changeLanguage}) {
//   return (
//     <>
//       <Header changeLanguage={changeLanguage}/>
//       <Outlet /> {/* renders child routes */}
//     </>
//   );
// }

// function App() {
//    const { t, i18n } = useTranslation();

//   const changeLanguage = (lang) => {
//     i18n.changeLanguage(lang);
//    document.dir = (lang === "ar" || lang === "ku") ? "rtl" : "ltr";
//   };

//   return (
//     <div className="App">
//     <Router>
//            <Routes>
//              {/* No header */}
//              <Route path="/dashboard" element={<DashboardPage />} />
//              <Route path="/appointments" element={<Appointments />} />
//              <Route path="/appointments-calender" element={<DoctorCalendar />} />
//              <Route path="/documents-under-process" element={<DocumentsUnderProcess />} />
//              <Route path="/patients" element={<Patients />} />
//              <Route path="/patients-profile" element={<PatientsProfile />} />
//              <Route path="/patient-registration" element={<PatientRegistration />} />
//              <Route path="/wallet" element={<Wallet />} />
//              <Route path="/withdraw-from-wallet" element={<WithdrawFromWallet />} />
//              <Route path="/my-profile" element={<MyProfile />} />
//              <Route path="/setting" element={<Setting />} />
//              <Route path="/help-and-support" element={<Faqs />} />
//              <Route path="/chat" element={<Chat />} />
//              <Route path="/doctor-support" element={<DoctorSupport />} />

//              {/* With header */}
//              <Route element={<LayoutWithHeader changeLanguage={changeLanguage}/>}>
//                <Route path="/" element={<LoginScreen />} />
//                <Route path="/introduction" element={<Introduction />} />
//                <Route path="/upload-required-documents" element={<UploadRequiredDocuments />} />
//                <Route path="/upload-documents" element={<UploadDocuments />} />
//                <Route path="/forgot-password" element={<ForgotPassword />} />
//                <Route path="/reset-password" element={<ResetPassword />} />

//              </Route>

//             {/* <Route path="/pharmacy-upload-required-documents" element={<UploadRequiredDocuments />} /> */}
//               <Route path="/pharmacy-upload-documents" element={<UploadDocumentsPharma />} />
//             <Route path="/pharmacy-dashboard" element={<PharmacyDashboard />} />
//             <Route path="/pharmacy-all-order" element={<PharmacyAllOrder />} />
//             <Route path="/pharmacy-orders-request" element={<PharmacyOrdersRequest />} />
//             {/* <Route path="/pharmacy-orders-history" element={<PharmacyOrdersHistory />} />  */}
//             <Route path="/pharmacy-orders-history" element={<PharmacyOrdersHistory />} />
//             <Route path="/pharmacy-order-details" element={<OrderDetails />} />
//             <Route path="/ducts" element={<PharamacyInventory />} />
//             <Route path="/pharmacy-manage-product" element={<PharmacyEditManageProduct />} />
//             <Route path="/pharmacy-add-medicine-to-inventory" element={<PharmacyAddMedicineToInventory />} />

//            </Routes>
//          </Router>
//     </div>
//   );
// }

// export default App;

import {
  BrowserRouter as Router,
  Routes,
  Route,
  Outlet,
} from "react-router-dom";
import "./App.css";
import Header from "./components/header/Header";
import { useTranslation } from "react-i18next";
import "./i18n";
import SessionManager from "./components/session-manager/SessionManager";
import ProtectedRoute from "./components/route-protection/ProtectedRoute";
import AccountDeactivatedModal from "./components/account-deactivated/AccountDeactivatedModal";

// Imaging module imports
import ImagingLogin from "./pages/imaging-module/login-screen/LoginScreen";
import ImagingForgotPass from "./pages/imaging-module/forgot-password/ForgotPassword";
import ForgotPassword from "./pages/forgot-password/ForgotPassword";
import ImagingResetPass from "./pages/imaging-module/reset-password/ResetPassword";
import ImagingDashboard from "./pages/imaging-module/dashboard/Dashboard";
import ImagingOrderManagement from "./pages/imaging-module/imaging-order-management/ImagingOrderManagement";
import ImagingSetting from "./pages/imaging-module/setting/Setting";
import ImagingChangePassword from "./pages/imaging-module/change-password/ChangePassword";
import ImagingChat from "./pages/imaging-module/chat/ImagingChat";
import ImagingChatList from "./pages/imaging-module/chat-list/ChatList";
import ImagingProfile from "./pages/imaging-module/imaging-profile/ImagingProfile";
import ImagingOnboarding from "./pages/imaging-module/imaging-onboarding/ImagingOnboarding";
import ImagingServicesAndPricing from "./pages/imaging-module/services-pricing/ServicesAndPricing";
import ImagingEarningPayment from "./pages/imaging-module/earning-payment/ImagingEarningPayment";
import ImagingTechnicianManagement from "./pages/imaging-module/technician-management/TechnicianManagement";
import ImagingAppointmentDetail from "./pages/imaging-module/imaging-appointment-detail/Imaging_appointment_detail";
import ImagingReportManagement from "./pages/imaging-module/imaging-report-management/ImagingReportManagement";
import PublicOrderDetail from "./pages/imaging-module/public-order-detail/PublicOrderDetail";
import ImagingWithdrawFromWallet from "./pages/imaging-module/withdraw-from-wallet/WithdrawFromWallet";

function LayoutWithHeader({ changeLanguage }) {
  return (
    <>
      <Header changeLanguage={changeLanguage} />
      <Outlet />
    </>
  );
}

function App() {
  const { t, i18n } = useTranslation();

  const changeLanguage = (lang) => {
    i18n.changeLanguage(lang);
    document.dir = lang === "ar" ? "rtl" : "ltr";
  };

  return (
    <SessionManager>
      <div className="App">
        <Router>
          <Routes>
            {/* Public routes - No authentication required */}
            <Route
              element={<LayoutWithHeader changeLanguage={changeLanguage} />}
            >
              <Route path="/" element={<ImagingLogin />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/imaging_forgot" element={<ImagingForgotPass />} />
              <Route path="/imaging_reset" element={<ImagingResetPass />} />
            </Route>

            {/* Protected Imaging routes (role_id: 10) */}
            <Route
              path="/imaging_dashboard"
              element={
                <ProtectedRoute allowedRoleId={10} redirectTo="/">
                  <ImagingDashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/imaging_ordermanagement"
              element={
                <ProtectedRoute allowedRoleId={10} redirectTo="/">
                  <ImagingOrderManagement />
                </ProtectedRoute>
              }
            />
            <Route
              path="/imaging_setting"
              element={
                <ProtectedRoute allowedRoleId={10} redirectTo="/">
                  <ImagingSetting />
                </ProtectedRoute>
              }
            />
            <Route
              path="/imaging_change_password"
              element={
                <ProtectedRoute allowedRoleId={10} redirectTo="/">
                  <ImagingChangePassword />
                </ProtectedRoute>
              }
            />
            <Route
              path="/imaging_chat"
              element={
                <ProtectedRoute allowedRoleId={10} redirectTo="/">
                  <ImagingChat />
                </ProtectedRoute>
              }
            />
            <Route
              path="/imaging_chatlist"
              element={
                <ProtectedRoute allowedRoleId={10} redirectTo="/">
                  <ImagingChatList />
                </ProtectedRoute>
              }
            />
            <Route
              path="/imaging_onboarding"
              element={
                <ProtectedRoute
                  allowedRoleId={10}
                  redirectTo="/"
                  requireOnboarding={false}
                >
                  <ImagingOnboarding />
                </ProtectedRoute>
              }
            />
            <Route
              path="/imaging_profile"
              element={
                <ProtectedRoute allowedRoleId={10} redirectTo="/">
                  <ImagingProfile />
                </ProtectedRoute>
              }
            />
            <Route
              path="/imaging_services"
              element={
                <ProtectedRoute allowedRoleId={10} redirectTo="/">
                  <ImagingServicesAndPricing />
                </ProtectedRoute>
              }
            />
            <Route
              path="/imaging_earning_payment"
              element={
                <ProtectedRoute allowedRoleId={10} redirectTo="/">
                  <ImagingEarningPayment />
                </ProtectedRoute>
              }
            />
            <Route
              path="/imaging_technicianmanagement"
              element={
                <ProtectedRoute allowedRoleId={10} redirectTo="/">
                  <ImagingTechnicianManagement />
                </ProtectedRoute>
              }
            />
            <Route
              path="/imaging_appointment_detail/:id"
              element={
                <ProtectedRoute allowedRoleId={10} redirectTo="/">
                  <ImagingAppointmentDetail />
                </ProtectedRoute>
              }
            />
            <Route
              path="/imaging_report-management"
              element={
                <ProtectedRoute allowedRoleId={10} redirectTo="/">
                  <ImagingReportManagement />
                </ProtectedRoute>
              }
            />
            <Route
              path="/imaging_withdraw_from_wallet"
              element={
                <ProtectedRoute allowedRoleId={10} redirectTo="/">
                  <ImagingWithdrawFromWallet />
                </ProtectedRoute>
              }
            />

            {/* Public imaging order detail - No authentication required */}
            <Route
              path="/public/appointment/:id"
              element={<PublicOrderDetail />}
            />

            {/* Unprotected routes for testing - REMOVE IN PRODUCTION */}
            {/* <Route path="/imaging_dashboard" element={<ImagingDashboard />} />
            <Route path="/imaging_ordermanagement" element={<ImagingOrderManagement />} />
            <Route path="/imaging_setting" element={<ImagingSetting />} />
            <Route path="/imaging_chat" element={<ImagingChat />} />
            <Route path="/imaging_chatlist" element={<ImagingChatList />} />
            <Route path="/imaging_profile" element={<ImagingProfile />} />
            <Route path="/imaging_services" element={<ImagingServicesAndPricing />} />
            <Route path="/imaging_earning_payment" element={<ImagingEarningPayment />} />
            <Route path="/imaging_technicianmanagement" element={<ImagingTechnicianManagement />} />
            <Route path="/imaging_appointment_detail" element={<ImagingAppointmentDetail />} />
            <Route path="/imaging_report-management" element={<ImagingReportManagement />} /> */}
          </Routes>
          <AccountDeactivatedModal />
        </Router>
      </div>
    </SessionManager>
  );
}

export default App;
